module.exports = __webpack_public_path__ + "static/media/growing_new_farmers_mobile.8310c0df.jpg";